export default "__VITE_ASSET__DjwTI6GZ__"